import React from "react";
import logo from "../img/logofgml.png";

const Footer = () => {
  return (
    <footer className="bg-light w-100 d-flex justify-content-center align-items-center p-4">
      <div className="logo">
        <a
          href="https://fundacionmohme.org/proyecto-democracia/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={logo} alt="Fundación Gustavo Mohme Llona" width="120" />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
